import { ReactNode } from 'react'
import MuiPopover from '@mui/material/Popover'

type Props = {
  target?: Element
  vertical: 'top' | 'bottom'
  horizontal: 'left' | 'right'
  children: ReactNode
  onClose?: () => void
}

export default function Popover({ target, vertical, horizontal, children, onClose }: Props) {
  return (
    <MuiPopover open={target !== undefined} anchorEl={target} anchorOrigin={{ vertical, horizontal }} onClose={onClose}>
      {children}
    </MuiPopover>
  )
}
